<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-27 12:13:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-20 15:22:05
 * @FilePath: /goldenSalesMobile/src/views/LayOut/index.vue
 * @Description: 首页tab页的layout
-->
<template>
  <div class="layout">
    <router-view />
    <!-- <home-tab-bar /> -->
  </div>
</template>

<script>
// import HomeTabBar from "@/components/MyTabBar/homeTabBar.vue";
export default {
  data() {
    return {};
  },
  components: {
    // HomeTabBar,
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.layout {
  // padding-bottom: 160px;
}
</style>
